import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
//import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
});

const rows = [
  { name : 'Type de Propriété:', detail : ['Maison']},

  { name : 'Superficie:', detail : ['130 m²']},
  { name : 'Règlement intérieur:', detail : [
    'Occupants maximums: 9',
    'Soirées/évènements non autorisés',
    'Animaux domestiques acceptés',
  ]},
  { name : 'Pièces de vie:', detail : [
    'Chambre 1 - Lit double 160cmx200cm',
    'Chambre 2 - 2 Lits simples 90cmx200cm',
    'Chambre 3 - Lit double 160cmx200cm',
    'Chambre 4 - 2 Lits simples 90cmx200cm',
    'Chambre 5 - 1 Lit simple 90cmx200cm',
    'Salon',
    'Salle à manger',
    'Jardin d\'hiver',
    'Cuisine avec coin repas'
   ]},
   { name : 'Sanitaires:', detail : [
    'rez de chaussée : 1 WC indépendant',
    '1er étage : 1 WC indépendant, 1 salle de bain avec baignoire et cabine de douche',
    '2nd étage : 1 salle d\'eau avec cabine de douche et WC' , 
   ]},
  { name : 'Autres:', detail : [
    'Garage fermé',
    'Jardin clos',
    'Terrasse',
    'Accès internet',
  ]},
  { name : 'Electroménager:', detail : [
    'Lave-linge',
    'Séche-linge',
    'Lave-vaisselle',
    'Réfrigérateur Congélateur',
    'Plaque de cuisson',
    'Four',
    'Four micro-ondes',
    'Aspirateur',
    'Planche et fer à repasser',
    'Sèche-cheveux',
    'Bouilloire',
    'Grille-pain',
    'Cafetière normale et cafetière Nespresso',
    'Presse-fruits',
    'Robot masterchef',
    'Mixeur',
  ]},
  { name : 'Equipements enfants:', detail : [
    'Lit parapluie',
    'Poussette',
    'Baignoire bébé',
    'Pot',
    'Réducteur WC'
  ]},
  { name : 'Equipements de loisirs:', detail : [
    'Lecteur DVD',
    'Table de billard',
    '3 Téléviseurs',
    'Cable/Satellite',
    'Radio'
  ]},
  { name : 'A l\'extérieur:', detail : [
    'Jardin paysagé',
    'Terrasse',
    'Salons de Jardin',
    'Barbecue',
    'Parasols',
   ]},
];



function Equipements(props) {
  const { classes } = props;
  let id =0;
  let item=0;
  return (
    <Paper className={classes.root}>
      <Table className={classes.table}>
        <TableBody>
          {rows.map(row => {
            return (
              <TableRow className={classes.row} key={id++}>
                <CustomTableCell component="th" scope="row">
                    {row.name}
                </CustomTableCell>
                <CustomTableCell>
                {row.detail.map(d => {
                    return (
                      <p key={item++}>{d}</p>
                    );
                  })}
                </CustomTableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  );
}

Equipements.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Equipements);



// WEBPACK FOOTER //
// ./src/Equipements.js